import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  DeleteDispatchIssueCausedByInput,
  DeleteDispatchIssueCausedByBulkResponse,
  MutationDeleteDispatchIssueCausedByBulkArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { DeleteDispatchIssueCausedBy } from '@/features/IssueHistory/api/queries/DeleteDispatchIssueCausedBy';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DeleteDispatchIssueCausedByInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteDispatchIssueCausedByBulkResponse>;
}

// DeleteDispatchIssueCausedBy Service
export const { deleteDispatchIssueCausedBy, useDeleteDispatchIssueCausedBy } = ((): {
  deleteDispatchIssueCausedBy: ServiceMethod;
  useDeleteDispatchIssueCausedBy: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(DeleteDispatchIssueCausedBy).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (
        payload?: DeleteDispatchIssueCausedByInput[],
        options?: ConnectionOptions
      ): Promise<DeleteDispatchIssueCausedByBulkResponse> => {
        const args: MutationDeleteDispatchIssueCausedByBulkArgs = {
          input: {
            search: payload,
          },
        };
        const opts = { merge: options?.merge ? 'deleteDispatchIssueCausedByBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('deleteDispatchIssueCausedByBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    deleteDispatchIssueCausedBy: fetch,
    useDeleteDispatchIssueCausedBy: useService,
  };
})();
